import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import MainMenu from '../../../node_modules/@getgo/chameleon-react/dist/MainMenu';
import MenuItemTemplates from '../../../node_modules/@getgo/chameleon-react/dist/MenuItemTemplates';
import AppConstants from '../../AppConstants';
import { connect } from 'react-redux';

export class MainMenuComponent extends Component {
  static contextTypes = {
    t: PropTypes.func.isRequired
  };
  static propTypes = {
    isBig: PropTypes.bool.isRequired,
    history: PropTypes.object,
    reduced_user: PropTypes.object
  };

  render() {
    const menuItems = this.getMenuItems();
    const { isBig } = this.props;
    return <MainMenu menuItems={menuItems} isSmall={!isBig} />;
  }

  getMenuItems() {
    const { t } = this.context;
    const { history, reduced_user } = this.props;
    const { isWdcEnabled, isOrganizerReportGenerationAllowed } = reduced_user.entitlements;
    const whiteIcon = { iconInlineStyle: { color: '#fff' } };
    const home = {
      ...MenuItemTemplates.getMenuItem('home'),
      ...whiteIcon,
      title: t('header.menu.dashboard'),
      onClick: () => {
        window.location = Routes.home;
      }
    };
    const analytics = {
      ...MenuItemTemplates.getMenuItem('analytics'),
      ...whiteIcon,
      title: t('header.menu.analytics'),
      iconClass: 'togo-icon togo-icon-barchart',
      onClick: () => {
        history.push(Routes.analytics);
      }
    };
    const myChannel = {
      ...MenuItemTemplates.getMenuItem('myChannel'),
      ...whiteIcon,
      title: t('header.menu.myChannel'),
      onClick: () => {
        window.location = Routes.myChannelNew;
      }
    };
    const content = {
      id: 'menu_item_content',
      key: 'menu_item_content',
      title: t('header.menu.videoLibrary'),
      iconClass: 'togo-icon togo-icon-videos',
      ...whiteIcon,
      onClick: () => {
        window.location = Routes.content;
      }
    };
    const settings = {
      ...MenuItemTemplates.getMenuItem('settings'),
      title: t('header.menu.settings'),
      ...whiteIcon,
      onClick: () => {
        window.location = Routes.settings;
      }
    };
    return [
      home,
      ...(isWdcEnabled ? [myChannel] : []),
      ...(isOrganizerReportGenerationAllowed ? [analytics] : []),
      content,
      settings
    ];
  }
}

const Routes = {
  home: `${AppConstants.G2W_DASHBOARD_URL}/#/`,
  myChannel: `${AppConstants.G2S_URL}/managechannels`,
  myChannelNew: `${AppConstants.G2W_DASHBOARD_URL}/#/manageChannels`,
  analytics: '/analytics/sessions',
  content: `${AppConstants.G2W_DASHBOARD_URL}/#/contentLibrary`,
  settings: `${AppConstants.G2W_DASHBOARD_URL}/#/settings`
};

export default withRouter(connect(state => ({ reduced_user: state.reduced_user }))(MainMenuComponent));



// WEBPACK FOOTER //
// ./src/Application/Header/MainMenuComponent.js